import { Col, Label, Row } from "client/CommonComponents"
import './AssetImage.scss';
import noImage from '../../../../../assets/images/no_image.png';

const AssetImage = (props:any) => {
  const { barcodeReportAssetImages } = props;

  return (
    <div className="asset-image-container">
      <div className="content-section mb-4">
        <Row className="mb-2">
          <Col xs={6} sm={6} md={3} lg={3} xl={3} className='mb-md-0 mb-3'>
            <Label className="bold-label mb-0" data-attribute="AssetImage_Default_Label">Asset #</Label>
            <Label data-attribute="AssetImage_Default_Label_2">{barcodeReportAssetImages?.assetNumber}</Label>
          </Col>
          <Col xs={6} sm={6} md={4} lg={4} xl={4} className='mb-md-0 mb-3'>
            <Label className="bold-label mb-0" data-attribute="AssetImage_Default_Label_3">VIN/Serial #</Label>
            <Label data-attribute="AssetImage_Default_Label_4">{barcodeReportAssetImages?.serialNo}</Label>
          </Col>
          <Col xs={6} sm={6} md={5} lg={5} xl={5} className='mb-md-0 mb-3'>
            <Label className="bold-label mb-0" data-attribute="AssetImage_Default_Label_5">Cost Center</Label>
            <Label data-attribute="AssetImage_Default_Label_6">{barcodeReportAssetImages?.costCenter}</Label>
          </Col>
          <Col xs={6} sm={6} md={3} lg={3} xl={3} className='mb-md-0 mb-3'>
            <Label className="bold-label mb-0" data-attribute="AssetImage_Default_Label_7">Product Code</Label>
            <Label data-attribute="AssetImage_Default_Label_8">{barcodeReportAssetImages?.productCode}</Label>
          </Col>
          <Col xs={6} sm={6} md={3} lg={3} xl={3} className='mb-md-0 mb-3'>
            <Label className="bold-label mb-0" data-attribute="AssetImage_Default_Label_9">Description</Label>
            <Label data-attribute="AssetImage_Default_Label_10">{barcodeReportAssetImages?.description}</Label>
          </Col>
        </Row>
      </div>
      <div className="image-section">
        <Row className="mb-2">
          <Col xs={12} sm={3} md={3} lg={3} xl={3} className='mb-md-0 mb-3'>
            <Label className="bold-label justify-content-center" data-attribute="AssetImage_Default_Label_11">Barcode Image</Label>
            <div className="image justify-content-center"><img src={barcodeReportAssetImages?.barcodeImage ? barcodeReportAssetImages?.barcodeImage : noImage} alt="" /></div>
          </Col>
          <Col xs={12} sm={3} md={3} lg={3} xl={3} className='mb-md-0 mb-3'>
            <Label className="bold-label justify-content-center" data-attribute="AssetImage_Default_Label_12">VIN Serial Number Image</Label>
            <div className="image justify-content-center"><img src={barcodeReportAssetImages?.serialNoImage ? barcodeReportAssetImages?.serialNoImage : noImage} alt="" /></div>
          </Col>
          {/* <Col xs={12} sm={3} md={3} lg={3} xl={3} className='mb-md-0 mb-3'>
            <Label className="bold-label justify-content-center" data-attribute="AssetImage_Default_Label_13">Asset Image</Label>
            <div className="image justify-content-center"><img src={barcodeReportAssetImages?.assetImage ? barcodeReportAssetImages?.assetImage : noImage} alt="" /></div>
          </Col>
          <Col xs={12} sm={3} md={3} lg={3} xl={3} className='mb-md-0 mb-3'>
            <Label className="bold-label justify-content-center" data-attribute="AssetImage_Default_Label_14">Odometer Hour Image</Label>
            <div className="image justify-content-center"><img src={barcodeReportAssetImages?.odometerImage ? barcodeReportAssetImages?.odometerImage : noImage} alt="" /></div>
          </Col> */}
        </Row>
      </div>
    </div>
  )
}

export default AssetImage